import React, { useState } from 'react';

import { motion } from 'framer-motion';
import styled from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import { Layout } from './components/Layout';
import { Hero, Skills, Experience, Education, Contact } from './components/features';
import { Intro } from './components/Intro';
import { CustomThemeProvider } from './context/ThemeContext';
import { ThemeSwitcher } from './components/shared/ThemeSwitcher';

const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.5 } },
};

const AppContainer = styled(motion.div)`
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
`;

const App: React.FC = () => {
  const [showIntro, setShowIntro] = useState(true);

  return (
    <CustomThemeProvider>
      <GlobalStyles />
      {showIntro ? (
        <Intro onComplete={() => setShowIntro(false)} />
      ) : (
        <AppContainer {...fadeIn}>
          <Layout>
            <Hero />
            <Skills />
            <Experience />
            {/* <Projects /> */}
            <Education />
            <Contact />
          </Layout>
          <ThemeSwitcher />
        </AppContainer>
      )}
    </CustomThemeProvider>
  );
};

export default App;
